import(/* webpackMode: "eager" */ "/codebuild/output/src955237198/src/esimify/node_modules/flag-icons/css/flag-icons.min.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src955237198/src/esimify/src/app/[lang]/sections/agencies.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src955237198/src/esimify/src/app/[lang]/sections/faq.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src955237198/src/esimify/src/app/[lang]/sections/hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src955237198/src/esimify/src/app/[lang]/sections/how-it-works/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LandingTracker"] */ "/codebuild/output/src955237198/src/esimify/src/app/[lang]/sections/landing-tracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src955237198/src/esimify/src/app/[lang]/sections/reviews.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src955237198/src/esimify/src/app/[lang]/top-countries.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src955237198/src/esimify/src/i18n/translation-provider.tsx");
